import { Link } from "react-router-dom";

const stats = [
  { label: "今日新增片段", value: "128", icon: "ri-add-circle-line" },
  { label: "已归档片段", value: "12,640", icon: "ri-archive-2-line" },
  { label: "标记高能瞬间", value: "3,900", icon: "ri-flashlight-line" },
];

export default function Hero() {
  return (
    <section className="relative w-full overflow-hidden" aria-label="爆料现场品牌首屏">
      <div className="absolute inset-0 h-full w-full">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20stylized%20illustration%20of%20a%20glowing%20live%20streaming%20broadcast%20stage%20with%20dramatic%20spotlight%20beams%20and%20floating%20rectangular%20screens%2C%20warm%20cream%20background%20with%20deep%20vermillion%20orange%20and%20golden%20amber%20accents%2C%20grainy%20editorial%20poster%20texture%2C%20cinematic%20high%20contrast%20lighting%2C%20modern%20magazine%20cover%20aesthetic%2C%20dynamic%20diagonal%20composition%2C%20no%20text&width=1600&height=1000&seq=bolo-hero-01&orientation=landscape"
          alt="爆料直播高能片段档案馆主视觉"
          title="爆料现场 爆料直播 高能片段档案馆"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/75" />
      </div>

      <div className="relative z-10 mx-auto flex w-full max-w-content flex-col items-center px-4 py-16 text-center md:px-6 md:py-28">
        <span className="bolao-rise inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-foreground-950/30 px-4 py-1.5 text-xs font-label tracking-[0.16em] text-background-50 uppercase">
          <span className="bolao-live-dot inline-block h-1.5 w-1.5 rounded-full bg-primary-400" />
          爆料直播 · 高能片段档案馆
        </span>

        <h1 className="bolao-rise mt-6 max-w-4xl font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl lg:text-6xl">
          错过直播不要紧
          <br />
          爆料现场帮你一字不漏地回顾
        </h1>

        <p className="bolao-rise mt-6 max-w-2xl font-body text-sm leading-relaxed text-background-100/90 md:text-base">
          我们整理【爆料直播】中真正有信息量的片段：主播关键发言、弹幕热议、高能时刻剪辑，
          以及可以逐句核对的直播内容文字版。现场的气氛，在这里重新被还原一次。
        </p>

        <div className="bolao-rise mt-8 flex w-full flex-col items-center justify-center gap-3 sm:flex-row">
          <Link
            to="/clips"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3.5 text-sm font-label font-medium text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            <i className="ri-play-list-2-line text-base" />
            进入爆料片段库
          </Link>
          <Link
            to="/clips?sort=hot"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-7 py-3.5 text-sm font-label font-medium text-background-50 transition-colors hover:bg-background-50/10 sm:w-auto"
          >
            <i className="ri-fire-line text-base" />
            查看今日高能榜
          </Link>
        </div>

        <dl className="bolao-rise mt-12 grid w-full max-w-3xl grid-cols-1 gap-4 sm:grid-cols-3">
          {stats.map((item) => (
            <div
              key={item.label}
              className="flex items-center gap-3 rounded-lg border border-background-50/20 bg-foreground-950/35 px-5 py-4 text-left"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500/90 text-primary-950">
                <i className={`${item.icon} text-lg`} />
              </span>
              <div className="flex flex-col">
                <dt className="text-xs font-label text-background-100/80">{item.label}</dt>
                <dd className="font-heading text-xl font-bold text-background-50">{item.value}</dd>
              </div>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}